import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const STORAGE_KEY = 'rota017_last_route';

// Rotas que NÃO devem ser salvas (são telas de transição)
const EXCLUDED_PREFIXES = ['/login', '/cadastro', '/acesso-bloqueado', '/'];

/**
 * useRoutePersistence
 * - Salva a última rota visitada do entregador autenticado em localStorage.
 * - Restaura a rota salva ao reabrir o app (foco em entregador, pois o PWA
 *   sempre relança o WebView em start_url quando o SO mata o processo).
 * - Para entregador sem rota salva, redireciona para /app/entregador por padrão.
 */
export const useRoutePersistence = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { usuario } = useAuth();

  // Salva rota atual sempre que mudar (apenas para entregador autenticado)
  useEffect(() => {
    if (!usuario || usuario.perfil !== 'entregador') return;
    const path = location.pathname + (location.search || '');
    if (EXCLUDED_PREFIXES.some((p) => path === p || (p !== '/' && path.startsWith(p)))) {
      return;
    }
    try {
      localStorage.setItem(STORAGE_KEY, path);
    } catch {
      /* localStorage cheio ou desabilitado — ignora */
    }
  }, [location.pathname, location.search, usuario]);

  // Ao montar: se o entregador caiu em "/" (porque o PWA relançou),
  // manda direto pra última rota salva (ou /app/entregador como fallback).
  useEffect(() => {
    if (!usuario || usuario.perfil !== 'entregador') return;
    if (location.pathname !== '/') return;
    let destino = '/app/entregador';
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && (saved.startsWith('/app/') || saved.startsWith('/dashboard/entregador'))) {
        destino = saved;
      }
    } catch {
      /* noop */
    }
    navigate(destino, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario]);
};

export default useRoutePersistence;
